import { type IDataObject } from '@inpart-io/devtools-iap';
import { type GetterTree } from 'vuex';

import { type ICheckStatusState } from './types';

export const GET_CHECK_STATUS_LIST = 'getCheckStatusList';

export function getGetters<T extends IDataObject>(): GetterTree<ICheckStatusState<T>, unknown> {
    return {
        [GET_CHECK_STATUS_LIST]: (_state) => {
            return (dobjId: number): T => {
                return _state.statusList.get(dobjId);
            };
        }
    };
}
